/**
 * pixels.js — fire a link's retargeting pixels client-side.
 *
 * The product resolves short links in the SPA Redirector (via /api/preview),
 * which never hits the server /api/r/{code} interstitial where the backend would
 * normally inject pixel scripts. So when a link carries pixels we fire them here,
 * in the browser, right before the redirect — same providers, same PageView.
 *
 * `pixels` shape: { facebook?, google?, pinterest?, tiktok? } (IDs).
 */

function inject(src) {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

export function firePixels(pixels) {
  if (!pixels || typeof pixels !== "object") return;

  // Meta / Facebook
  if (pixels.facebook) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", pixels.facebook);
    window.fbq("track", "PageView");
  }

  // Google — GTM container or GA4 / gtag
  if (pixels.google) {
    const id = pixels.google;
    if (id.startsWith("GTM-")) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
      inject(`https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(id)}`);
    } else {
      inject(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`);
      window.dataLayer = window.dataLayer || [];
      // eslint-disable-next-line no-inner-declarations
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", id);
    }
  }

  // Pinterest
  if (pixels.pinterest) {
    /* eslint-disable */
    !(function (e) {
      if (!window.pintrk) {
        window.pintrk = function () {
          window.pintrk.queue.push(Array.prototype.slice.call(arguments));
        };
        var n = window.pintrk;
        n.queue = [];
        n.version = "3.0";
        var t = document.createElement("script");
        t.async = !0;
        t.src = e;
        var r = document.getElementsByTagName("script")[0];
        r.parentNode.insertBefore(t, r);
      }
    })("https://s.pinimg.com/ct/core.js");
    /* eslint-enable */
    window.pintrk("load", pixels.pinterest);
    window.pintrk("page");
  }

  // TikTok
  if (pixels.tiktok) {
    /* eslint-disable */
    !(function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = (w[t] = w[t] || []);
      ttq.methods = [
        "page",
        "track",
        "identify",
        "instances",
        "debug",
        "on",
        "off",
        "once",
        "ready",
        "alias",
        "group",
        "enableCookie",
        "disableCookie",
      ];
      ttq.setAndDefer = function (t, e) {
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.load = function (e) {
        var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
        ttq._i = ttq._i || {};
        ttq._i[e] = [];
        ttq._i[e]._u = i;
        ttq._t = ttq._t || {};
        ttq._t[e] = +new Date();
        var o = d.createElement("script");
        o.type = "text/javascript";
        o.async = !0;
        o.src = i + "?sdkid=" + e + "&lib=" + t;
        var a = d.getElementsByTagName("script")[0];
        a.parentNode.insertBefore(o, a);
      };
    })(window, document, "ttq");
    /* eslint-enable */
    window.ttq.load(pixels.tiktok);
    window.ttq.page();
  }
}

export default firePixels;
